export enum Colors {
  White = "#ffffff",
  Black = "#000000",
  Charcoal = "#404040",
  BorderGrey = "#D3D5D9",
  MidGrey = "#888888",
  LightGrey = "#ECECEC",

  DarkModeBlack = "#0D0D0D",
  DarkModeWhite = "#F0F0F0",
  DarkModeOffWhite = "#D1D1D1",
  DarkModeOffBlack = "#202020",
  DarkModeBorderGrey = "#3D3D3D",

  Orange = "#F2994A",
  Green = "#00B88C",
  Red = "#EB5757",
}
